import { TrInfoHeaderComponent } from './../table/tr-info-header/tr-info-header.component';
import { ConfirmationDialogComponent } from './../confirmation-dialog/confirmation-dialog.component';
import { PropertyType } from '../Product/PropertyType';
import { AngularFirestore } from '@angular/fire/firestore';
import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

import { TrTableComponent } from '../table/tr-table.component';
import { CustomerDao } from '../test/customer.dao';
import { Customer } from '../test/customer.model';
import { CustomValidators } from '../validators/custom-validator';
import { EditCustomerComponent } from './edit-customer/edit-customer.component';
import { CustomerService } from '../test/customer.service';

@Component({
  selector: 'lsu-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomerComponent implements OnInit {

  constructor(
    public firestore: AngularFirestore,
    public customerService: CustomerService,
    public dialog: MatDialog,
    public router: Router,
    private route: ActivatedRoute,
    public fb: FormBuilder,
  ) {
    this.propertyTypes = []
  }


  @ViewChild(TrTableComponent, { static: true })
  public table: TrTableComponent<any>

  public formGroup = this.fb.group({
    _id: this.fb.control(""),
    name: this.fb.control(""),
    propertyType: this.fb.control(""),
    phone: this.fb.control("", [Validators.required, Validators.pattern(/^(?!0+$)(?:\(?\+\d{1,3}\)?[- ]?|0)?\d{10}$/)]),
    // email: this.fb.control("", [Validators.email], [CustomValidators.checkEmail(this.firestore)]),
    email: this.fb.control(""),
    address: this.fb.control(""),
    notes: this.fb.control(""),
  })
  propertyTypes: PropertyType[];
  public subscription: Subscription
  public dao: CustomerDao
  public columns: string[] = [
    "propertyType",
    "name",
    "email",
    "phone",
    "address",
    "notes",
    "action"
  ]
  public formErrors = {
    name: '',
    email: '',
    phone: '',
  }

  public async ngOnInit(): Promise<void> {
    this.dao = new CustomerDao(this.customerService)
    await this.dao.initialize()
    await this.getPropertyTypes();
  }

  public async getPropertyTypes(): Promise<void> {
    const querySnapshot = await this.customerService.getPropertyTypes()
    querySnapshot.forEach(doc => {
      this.propertyTypes.push({ name: doc.data().name, id: doc.id })
    })
  }
  public async getCustomer(customerId: string): Promise<any> {
    const customer = await this.firestore
      .collection('customers')
      .doc(customerId)
      .ref.get()

    return customer.data()
  }

  public ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  public onAddCustomer(addCustomerDialog: TemplateRef<any>): void {
    this.dialog.open(addCustomerDialog)
  }

  public async addCustomer(): Promise<void> {
    const customer = this.formGroup.value as Customer;
    let customerId;
    const ref = await this.customerService.addCustomer(customer)
    customerId = ref.id
    await this.table.addItem(customer, null)
    this.router.navigateByUrl(`customers/${customerId}/quotes`)

  }
  // Use getters for cleaner HTML code
  get email() {
    return this.formGroup.get('email')
  }

  get name() {
    return this.formGroup.get('name')
  }

  async openDialog(data, event: MouseEvent): Promise<void> {
    event.stopPropagation()
    const propertyTypeControl = this.formGroup.get("propertyType")
    propertyTypeControl.setValue(data.propertyType)
    const dialogRef = this.dialog.open(EditCustomerComponent, {
      width: '350px',
      data: data
    });

    const customerUpdated = await dialogRef.afterClosed().toPromise<Customer>()
    if (customerUpdated) {
      await this.table.updateItem(customerUpdated)
    }
  }

  async onDeleteCustomer(customerId: string, event: MouseEvent): Promise<void> {
    event.stopPropagation()
    if (customerId) {
      const ref = this.dialog.open(ConfirmationDialogComponent, {
        data: { title: `Are you sure you want to delete '${this.dao.dataMap[customerId].name}'` }
      })

      const shouldDelete = await ref.afterClosed().toPromise()
      if (shouldDelete) {
        this.deleteCustomer(customerId)
      }
    }
  }

  async deleteCustomer(customerId: string): Promise<void> {
    return this.table.deleteItem(customerId, async () => {
      this.customerService.deleteCustomer(customerId)
    })
  }
}

